import { render } from "./PlanSearch.vue?vue&type=template&id=6ab87235"
import script from "./PlanSearch.vue?vue&type=script&lang=js"
export * from "./PlanSearch.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__